import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFirstComponent } from '../Reducers/Configurator/Actions';

export const useFirstComponentCheck = ({ active }) => {
  const configurator = useSelector((state) => state.configurator);
  const loadedConfigurationIdentifier = configurator.configuration?.item?.identifier;
  const dispatch = useDispatch();
  const { selectedoptionclassification } = configurator;
  const noComponentSelected = !selectedoptionclassification.identifier;
  const noCheckedComponent = !Object.keys(configurator.checkedOptionclassifications).length;
  useEffect(() => {
    active &&
      loadedConfigurationIdentifier &&
      noComponentSelected &&
      noCheckedComponent &&
      dispatch(selectFirstComponent());
  }, [active, loadedConfigurationIdentifier, noComponentSelected, noCheckedComponent, dispatch]);
};
